import { restApiActions } from 'redux/redux-actions';

export const storeItemsImageActions = restApiActions('store-items', 'image');
export const marketPlaceProductsActions = restApiActions('market-place-products');
export default restApiActions('store-items');
